import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const sent = defineConnector({
  identifier: "sent",
  name: "Sent",
  tagLine: "SMS, WhatsApp, and RCS messaging",
  keywords: "sent.dm sentdm texting phone numbers contacts templates",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () => "https://api\\.sent\\.dm/.*",
  auth: (app) => headerAuth([{ name: "x-api-key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Create an API key",
      items: [
        {
          kind: "markdown",
          content:
            "In the [Sent dashboard](https://app.sent.dm/), open **Development → API Keys** and select **Add API Key**. Name the key, select **Create Key**, and copy its value. See the [API key guide](https://docs.sent.dm/start/guides/api-keys) for details.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.sent.dm/v3/me",
  },
});
